import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

const MSG = {
  live: "Switch to LIVE? Public checkout will charge real cards, new records are live, and admin views show live records only. Demo records are kept.",
  demo: "Switch back to DEMO? Public checkout becomes simulated and admin views show demo records only. Live records are kept.",
};

function Blockers({ items, busy, onCheck, onClose }) {
  return (
    <div className="absolute right-0 top-full z-50 mt-2 w-96 rounded border border-slate-300 bg-white p-3 text-xs shadow-lg" role="alert" data-testid="admin-mode-blockers">
      <p className="font-semibold text-burgundy">Live is blocked by:</p>
      <ul className="list-disc pl-5">{items.map((b) => <li key={b}>{b}</li>)}</ul>
      <div className="mt-2 flex gap-2">
        <button type="button" className="btn-primary btn-sm" disabled={busy} onClick={onCheck} data-testid="admin-mode-run-check-btn">{busy ? "Checking…" : "Run check now"}</button>
        <button type="button" className="btn-outline btn-sm" onClick={onClose} data-testid="admin-mode-blockers-close">Close</button>
      </div>
    </div>
  );
}

export function ModeButtons({ live, canSwitch }) {
  const [blockers, setBlockers] = useState(null);
  const [busy, setBusy] = useState(false);
  if (!canSwitch) {
    return <span className={`rounded px-2 py-0.5 text-xs font-bold ${live ? "bg-green-700 text-white" : "bg-amber-400 text-navy"}`} data-testid="admin-mode-badge">{live ? "LIVE" : "DEMO MODE"}</span>;
  }
  const go = async (to) => {
    if (busy || (to === "live") === live) return;
    if (!window.confirm(MSG[to])) return;
    setBusy(true);
    setBlockers(null);
    try {
      await api.put("/admin/operating-mode", { mode: to, confirm: true });
      toast.success(`Operating mode: ${to.toUpperCase()}`);
      window.location.reload();
    } catch (e) {
      toast.error(errMsg(e));
      try {
        const { data } = await api.get("/admin/operating-mode");
        if (data.live_blockers?.length) setBlockers(data.live_blockers);
      } catch (_) { /* retain original actionable error */ }
    } finally { setBusy(false); }
  };
  const check = async () => {
    setBusy(true);
    try { await api.post("/admin/integrations/gateway/live-test/precheck"); const { data } = await api.get("/admin/operating-mode"); setBlockers(data.live_blockers.length ? data.live_blockers : null); if (!data.live_blockers.length) toast.success("Check passed – click LIVE to switch"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const cls = (on, color) => `px-3 py-1 text-xs font-bold transition-colors ${on ? `${color} text-white` : "bg-white text-slate-600 hover:bg-slate-100"}`;
  return (
    <div className="relative">
      <div className="inline-flex overflow-hidden rounded border border-slate-300" role="group" aria-label="Operating mode" data-testid="admin-mode-buttons">
        <button type="button" disabled={busy} aria-pressed={!live} className={cls(!live, "bg-amber-500")} onClick={() => go("demo")} data-testid="admin-mode-demo-btn">DEMO</button>
        <button type="button" disabled={busy} aria-pressed={live} className={cls(live, "bg-green-700")} onClick={() => go("live")} data-testid="admin-mode-live-btn">LIVE</button>
      </div>
      {blockers && <Blockers items={blockers} busy={busy} onCheck={check} onClose={() => setBlockers(null)} />}
    </div>
  );
}
